// Module augmentation to support custom object within Theme object
export enum ThemeType {
  CAH,
  MSA,
  AMFAM,
}

declare module "@material-ui/core/styles" {
  interface Theme {
    custom: {
      colors: {
        primaryColor: string;
        secondaryColor: string;
        headerTopBorderColor: string;
        headerBottomBorderColor: string;
        headerBackgroundColor: string;
        footerBackGroundColor: string;
        listSelectionBackgroundColor: string;
        mainBackgroundColor: string;
        footerTextColor: string;
        footerTopBorderColor: string;
        listItemHoverColor: string;
        loadingSpinnerTopColor: string;
        loadingSpinnerBottomColor: string;
        loadingSpinnerHeaderColor: string;
      };
      links: {
        contactUsLink: string;
        logoLink: string;
        termsAndConditionsLink: string;
        companyInformation: string;
      };
      text: {
        footerText: string;
        title: string;
        description: string;
        contactNumber: string;
        noShopsFoundMessage: string;
      };
      styles: {
        linearProgressBarStyle: {
          borderRadius: string;
          primaryBarColor: string;
          secondaryBarColor: string;
          header: {
            fontSize: number;
            fontWeight: number;
            color: string;
          };
          description: {
            fontSize: number;
            fontWeight: number;
            color: string;
          };
        };
        headerSpinner: {
          fontFamily?: string;
          fontWeight?: number;
          fontSize?: string;
          color?: string;
          textDecorationColor?: string;
        };

        headerContactUs: {
          fontFamily: string;
          fontWeight: number;
          fontSize: string;
          color: string;
        };

        headerSecondary: {
          fontFamily?: string;
          fontWeight?: number;
          fontSize?: string;
          color?: string;
          textDecorationColor?: string;
        };

        headerSub: {
          fontFamily?: string;
          fontWeight?: number;
          fontSize?: string;
          color?: string;
          textDecorationColor?: string;
        };

        headerTitle: {
          fontFamily: string;
          fontWeight: number;
          fontSize: string;
          color: string;
        };
        primaryDescription: {
          fontFamily: string;
          fontWeight: number;
          fontSize: string;
          color: string;
        };
        primaryLabel: {
          fontFamily: string;
          fontWeight: number;
          fontSize: string;
          color: string;
        };
        secondaryDescription: {
          fontFamily: string;
          fontWeight: number;
          fontSize: string;
          color: string;
        };
        linkText: {
          fontFamily: string;
          fontWeight: number;
          fontSize: string;
          color: string;
          textTransform:
            | "-moz-initial"
            | "inherit"
            | "initial"
            | "revert"
            | "unset"
            | "none"
            | "full-width"
            | "capitalize"
            | "full-size-kana"
            | "lowercase"
            | "uppercase";
          order: number;
          "@media (max-width: 480px)": {
            order: number;
            marginBottom: string;
            fontWeight: number;
            fontSize: string;
          };
        };
        linkButtonText: {
          fontFamily: string;
          fontWeight: number;
          fontSize: string;
          color: string;
          textTransform:
            | "-moz-initial"
            | "inherit"
            | "initial"
            | "revert"
            | "unset"
            | "none"
            | "full-width"
            | "capitalize"
            | "full-size-kana"
            | "lowercase"
            | "uppercase";
          order: number;
          "@media (max-width: 480px)": {
            order: number;
            marginBottom: string;
          };
        };
        hiddenPadding: string;
        rowSpan: {
          order: number;
          flexGrow: number;
        };
        themeType?: {
          currentThemeType: ThemeType;
        };
        uploadButton?: {
          height?: string;
          minWidth?: string;
          textTransform:
            | "-moz-initial"
            | "inherit"
            | "initial"
            | "revert"
            | "unset"
            | "none"
            | "full-width"
            | "capitalize"
            | "full-size-kana"
            | "lowercase"
            | "uppercase";
        };
        submitButton: {
          textTransform:
            | "-moz-initial"
            | "inherit"
            | "initial"
            | "revert"
            | "unset"
            | "none"
            | "full-width"
            | "capitalize"
            | "full-size-kana"
            | "lowercase"
            | "uppercase";
          order: number;
          backgroundColor: string;
          color: string;
          fontSize: string;
          fontWeight: number;
          borderRadius: string;
          "@media (max-width: 480px)": {
            order: number;
            width: string;
            marginRight: string;
            marginLeft: string;
            marginBottom: string;
          };
          "&:hover": {
            backgroundColor: string;
          };
        };
        iconColor: string;
      };
    };
  }
  interface ThemeOptions {
    custom?: {
      colors?: {
        primaryColor?: string;
        secondaryColor?: string;
        headerTopBorderColor?: string;
        headerBottomBorderColor?: string;
        headerBackgroundColor?: string;
        footerBackGroundColor?: string;
        listSelectionBackgroundColor?: string;
        mainBackgroundColor?: string;
        footerTextColor?: string;
        footerTopBorderColor?: string;
        listItemHoverColor?: string;
        loadingSpinnerTopColor?: string;
        loadingSpinnerBottomColor?: string;
        loadingSpinnerHeaderColor?: string;
      };
      links?: {
        contactUsLink?: string;
        logoLink?: string;
        termsAndConditionsLink?: string;
        companyInformation?: string;
      };
      text?: {
        footerText?: string;
        title?: string;
        description?: string;
        contactNumber?: string;
        noShopsFoundMessage?: string;
      };
      styles?: {
        linearProgressBarStyle?: {
          borderRadius?: string;
          primaryBarColor?: string;
          secondaryBarColor?: string;
          header?: {
            fontSize?: number;
            fontWeight?: number;
            color?: string;
          };
          description?: {
            fontSize?: number;
            fontWeight?: number;
            color?: string;
          };
        };
        headerSpinner: {
          fontFamily?: string;
          fontWeight?: number;
          fontSize?: string;
          color?: string;
          textDecorationColor?: string;
        };
        headerSecondary: {
          fontFamily?: string;
          fontWeight?: number;
          fontSize?: string;
          color?: string;
          textDecorationColor?: string;
        };
        headerSub: {
          fontFamily?: string;
          fontWeight?: number;
          fontSize?: string;
          color?: string;
          textDecorationColor?: string;
        };
        headerContactUs?: {
          fontFamily?: string;
          fontWeight?: number;
          fontSize?: string;
          color?: string;
          textDecorationColor?: string;
        };
        headerTitle?: {
          fontFamily?: string;
          fontWeight?: number;
          fontSize?: string;
          color?: string;
        };
        primaryDescription?: {
          fontFamily?: string;
          fontWeight?: number;
          fontSize?: string;
          color?: string;
        };
        primaryLabel?: {
          fontFamily?: string;
          fontWeight?: number;
          fontSize?: string;
          color?: string;
        };
        secondaryDescription?: {
          fontFamily?: string;
          fontWeight?: number;
          fontSize?: string;
          color?: string;
        };
        linkText: {
          fontFamily: string;
          fontWeight: number;
          fontSize: string;
          color: string;
          textTransform:
            | "-moz-initial"
            | "inherit"
            | "initial"
            | "revert"
            | "unset"
            | "none"
            | "full-width"
            | "capitalize"
            | "full-size-kana"
            | "lowercase"
            | "uppercase";
          order: number;
          "@media (max-width: 480px)": {
            order: number;
            marginBottom: string;
            fontWeight?: number;
            fontSize?: string;
          };
        };
        linkButtonText: {
          fontFamily: string;
          fontWeight: number;
          fontSize: string;
          color: string;
          textTransform:
            | "-moz-initial"
            | "inherit"
            | "initial"
            | "revert"
            | "unset"
            | "none"
            | "full-width"
            | "capitalize"
            | "full-size-kana"
            | "lowercase"
            | "uppercase";
          order: number;
          "@media (max-width: 480px)": {
            order: number;
            marginBottom: string;
          };
        };
        hiddenPadding: string;
        rowSpan: {
          order: number;
          flexGrow: number;
        };
        uploadButton?: {
          height?: string;
          minWidth?: string;
          textTransform:
            | "-moz-initial"
            | "inherit"
            | "initial"
            | "revert"
            | "unset"
            | "none"
            | "full-width"
            | "capitalize"
            | "full-size-kana"
            | "lowercase"
            | "uppercase";
        };
        submitButton: {
          textTransform:
            | "-moz-initial"
            | "inherit"
            | "initial"
            | "revert"
            | "unset"
            | "none"
            | "full-width"
            | "capitalize"
            | "full-size-kana"
            | "lowercase"
            | "uppercase";
          order: number;
          backgroundColor: string;
          color: string;
          fontSize: string;
          fontWeight: number;
          borderRadius: string;
          "@media (max-width: 480px)": {
            order: number;
            width: string;
            marginRight: string;
            marginLeft: string;
            marginBottom: string;
          };
          "&:hover": {
            backgroundColor: string;
          };
        };
        themeType?: {
          currentThemeType?: ThemeType;
        };
        iconColor: string;
      };
    };
  }
}
